import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import Button from "@material-ui/core/Button";
import ColorPicker from "../../../../../ReusableComponents/ColorPicker/ColorPicker";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 200,
    color: "#fff",
  },
}));

function ColorBox(props) {
  return (
    <div
      onClick={() => props.openColorPicker(props.item.index)}
      className={style.colorPalleteColorbox}
      style={props.style}
    ></div>
  );
}

const EditableColorPallete = (props) => {
  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const [colorPalleteColors, setColorPalleteColors] = useState(
    props.colorPalleteColors && props.colorPalleteColors.slice()
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showColorPickerKey, setShowColorPickerKey] = useState(false);

  function editColorPallete(colorIndex, arg1, arg2) {
    setColorPalleteColors(
      colorPalleteColors.map((colorDetails) => {
        if (colorDetails.index === colorIndex) {
          return { ...colorDetails, backgroundColor: arg2 };
        }
        return colorDetails;
      })
    );
  }
  useEffect(() => {
    document.getElementById("backdropDiv")?.focus();
  }, []);

  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      props.handleBackdrop("cancel");
    }
  }

  function openColorPicker(colorIndex) {
    setShowColorPicker((prev) => colorIndex);
    setShowColorPickerKey((prev) => Math.random() + colorIndex);
  }
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      <div
        tabIndex="0"
        onKeyDown={(e) => handleEscapeKey(e)}
        className={style.colorPalleteBackdropDiv}
        key={showColorPickerKey}
        id="backdropDiv"
      >
        <Row
          className={style.colorPalleteBackdropHeader}
          style={translationStyles ? { marginRight: "unset" } : null}
        >
          {t("translation:Edit Color Pallete")}
        </Row>
        <Row className={style.colorPalleteParentDiv} key={showColorPickerKey}>
          <Col
            className={style.colorPalleteLeftDiv}
            key={Math.random()}
            style={{ marginRight: t("styles:colorPaletteMarginRight") }}
          >
            {colorPalleteColors &&
              colorPalleteColors
                .slice(colorPalleteColors.length / 2)
                .reverse()
                .map((item, index) => {
                  return (
                    <Row className={style.colorPalleteRow}>
                      <Col className={style.colorBoxCol}>
                        <ColorBox
                          openColorPicker={openColorPicker}
                          item={item}
                          style={{ backgroundColor: item["backgroundColor"] }}
                        />
                      </Col>
                      <Col className={style.colorDetailsCol}>
                        <p className={style.colorDetailsP1}>
                          {item["colorName"]}
                        </p>
                        <p className={style.colorDetailsP2}>
                          {item["backgroundColor"]}
                        </p>
                      </Col>
                      <Col className={style.editColorBoxCol}>
                        <img
                          src={
                            require("../../../../../Icons/EditIcon.svg").default
                          }
                          alt="edit"
                          style={{ marginLeft: "auto" }}
                          onClick={() => openColorPicker(item.index)}
                        />
                      </Col>
                      {showColorPicker === item.index && (
                        <ColorPicker
                          color={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          show1={true}
                          key={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          propertyName={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          colorPickerInputStyle={{ display: "none" }}
                          handleProperty={(arg1, arg2) =>
                            editColorPallete(showColorPicker, arg1, arg2)
                          }
                        />
                      )}
                    </Row>
                  );
                })}
          </Col>

          <Col className={style.colorPalleteRightDiv}>
            {colorPalleteColors &&
              colorPalleteColors
                .slice(0, colorPalleteColors.length / 2)
                .map((item, index) => {
                  return (
                    <Row className={style.colorPalleteRow}>
                      <Col className={style.colorBoxCol}>
                        <ColorBox
                          openColorPicker={openColorPicker}
                          item={item}
                          style={{ backgroundColor: item["backgroundColor"] }}
                        />
                      </Col>
                      <Col className={style.colorDetailsCol}>
                        <p className={style.colorDetailsP1}>
                          {item["colorName"]}
                        </p>
                        <p className={style.colorDetailsP2}>
                          {item["backgroundColor"]}
                        </p>
                      </Col>
                      <Col className={style.editColorBoxCol}>
                        <img
                          src={
                            require("../../../../../Icons/EditIcon.svg").default
                          }
                          alt="edit"
                          style={{ marginLeft: "auto" }}
                          onClick={() => openColorPicker(item.index)}
                        />
                      </Col>
                      {showColorPicker === item.index && (
                        <ColorPicker
                          show1={true}
                          color={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          key={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          propertyName={
                            colorPalleteColors[showColorPicker].backgroundColor
                          }
                          colorPickerInputStyle={{ display: "none" }}
                          handleProperty={(arg1, arg2) =>
                            editColorPallete(showColorPicker, arg1, arg2)
                          }
                        />
                      )}
                    </Row>
                  );
                })}
          </Col>
        </Row>
        <Row
          className={style.colorPalleteBackdropFooter}
          style={
            translationStyles
              ? { margin: "0", justifyContent: "flex-end" }
              : { margin: "0" }
          }
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.saveButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() => props.handleBackdrop("save", colorPalleteColors)}
          >
            {t("translation:Save")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.cancelButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() => props.handleBackdrop("cancel")}
          >
            {t("translation:Cancel")}
          </Button>
        </Row>
      </div>
    </Backdrop>
  );
};

export default EditableColorPallete;
